export default "__VITE_ASSET__C4dzx7j5__"